// Base util
export const isArrayOf = <T>(
  arr: unknown[],
  guard: (item: unknown) => item is T,
): arr is T[] => arr.every(guard);

// Individual guards
export const isNull = (item: unknown): item is null => item === "null";

export const isBoolean = (item: unknown): item is boolean =>
  typeof item === "boolean";

export const isString = (item: unknown): item is string =>
  typeof item === "string";

export const isNumber = (item: unknown): item is number =>
  typeof item === "number";

// Canned array guards — single-param, ready to use
export const isStringArray = (arr: unknown[]): arr is string[] =>
  isArrayOf(arr, isString);

export const isNumberArray = (arr: unknown[]): arr is number[] =>
  isArrayOf(arr, isNumber);
